import {useEffect} from 'react'
import {useNavigate} from 'react-router'

export const RedirectTo = ({path}) => {
  const nav = useNavigate()
  useEffect(() => nav(path))
  return <></>
}
